const getInsertion = (content, values) => content.replace(/\{\{(.*?)\}\}/g, (_, key) => (values[key] ?? "").toString());
export {
  getInsertion
};
//# sourceMappingURL=getInsertion.mjs.map